(function ShipSchedule($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Itineraries/shipSchedule/', function onload()
		{
			$("a.info-link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    body  = $self.data('content') || $($self.data('modal-id')).html();

				e.preventDefault();
				$modal.find('.modal-title').text($self.text());
				$modal.find('.modal-body').html(body);
				$modal.modal('show');
			});

			$modal.on('click', '.image-link > a', function showDeck(e)
			{
				var $self    = $(this),
				    type     = $self.data('type'),
				    image_id = $self.data(type+'-id');

				e.preventDefault();
				$modal.find('.'+type+'-image').hide();
				$modal.find('.'+type+'-image[data-'+type+'-id="'+image_id+'"]').show();
				$modal.find('.image-link > a.active').removeClass('active');
				$self.addClass('active');
			});
		});
	});

}(jQuery, window.Adzuki || {}));